<template>
  <div>
    <section v-if="type === 'blog'" class="hero is-light-bg signup">
      <div class="wave-top">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#f3f7f9" fill-opacity="1" d="M0,64L48,69.3C96,75,192,85,288,117.3C384,149,480,203,576,192C672,181,768,107,864,85.3C960,64,1056,96,1152,133.3C1248,171,1344,213,1392,234.7L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" /></svg>
      </div>
      <div class="hero-body has-text-centered m-t-50 m-b-50">
        <div class="container has-text-centered">
          <h2 class="title is-2 has-text-centered">Make your events more engaging</h2>
          <p>Sign up for a free account and start customizing your events today &mdash; SlidesWith is the easiest way to build stronger remote connections.</p>
          <b-field position="is-centered" class="m-t-50">
            <b-input v-model="email" placeholder="Enter your email..." type="text" size="is-medium" />
            <p class="control">
              <button @click="startRegister(); trackEvent('Blog Footer CTA')" class="button is-primary is-medium">Try it free</button>
            </p>
          </b-field>
        </div>
      </div>
    </section>
    <section class="hero is-dark footer">
      <div class="hero-body has-text-centered ">
        <div class="container is-fluid has-text-centered">
          <div class="columns">
            <div class="column is-3">
              <img src="/swf-logo.svg" class="logo m-b-20">
              <p style="opacity: .4">&copy;2020 Darkgrey Media, LLC</p>
            </div>
            <div class="column" />
            <div class="column is-3">
              <a href="/blog">Our Blog &mdash; Making Remote Work 💪</a>
              <a href="/about-us">Meet the team</a>
              <a href="/pricing">Pricing</a>
              <a href="/c/terms">Terms of Service</a>
              <a href="/c/privacy-policy">Privacy Policy</a>
            </div>
            <div class="column is-4">
              <n-link v-if="!$auth.loggedIn" to="/login">Login</n-link>
              <a v-else @click="logout" :class="{'is-disabled': loggingOut}">Logout</a>
              <n-link v-if="isManager" to="/admin/users">User Data</n-link>
              <n-link to="/go">Join an Event</n-link>
              <!-- <n-link to="/c/contact">Get in touch</n-link> -->
              <div class="social">
                <a target="_blank" href="https://www.instagram.com/slideswith/">
                  <b-icon pack="fab" icon="instagram" size="is-medium" />
                </a>
                <a target="_blank" href="https://twitter.com/slideswith">
                  <b-icon pack="fab" icon="twitter-square" size="is-medium" />
                </a>
              </div>
            </div>
            <div class="column" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: ['type'],
  data () {
    return {
      email: '',
      loggingOut: false
    }
  },
  methods: {
    startRegister () {
      this.$router.push({ path: '/register', query: { email: this.email } })
    },
    isManager () {
      return this.$auth && this.$auth.user && this.$auth.user.default_role === 'manager'
    },
    async logout () {
      this.loggingOut = true
      await this.$apolloHelpers.onLogout()
      await this.$auth.logout()
    }
  }
}
</script>

<style lang="scss" scoped>
.signup {
  z-index: -10;
}
.wave-top {
  position: relative;
  width: 100%;
  background-color: white;
  margin: 0 auto -16vw;
  padding: 0px;

  svg {
    position: relative;
    bottom: -10px;
    margin: 0;
    padding: 0;
  }
}

.signup {
  .wave-top {
    margin: -4vw auto -10vw;
  }
}

.is-disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
